import { Button } from 'component/Button'
import { Gap } from 'component/Space/Gap'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { EmailForm } from 'page/ProfileScreen/Email/EmailForm'
import { ProfileForm } from 'page/ProfileScreen/ProfileForm/ProfileForm'
import { SaveButtonPane } from 'page/ProfileScreen/SaveButton/SaveButtonPane'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const RegularView = observer(() => {
  const { needEmail } = store
  const data_management = false // !me.external && !opt.stand
  const next = !me.email

  const onData = useLatestCallback(async () => {
    store.profile.step = 'data'
  })

  return (
    <Vertical minHeight="var(--page-viewport-height-simple)">
      <ProfileForm />

      {!next && needEmail && <Gap height={24} />}
      {!next && needEmail && <EmailForm />}

      <Gap spring height={12} />
      <SaveButtonPane />

      {data_management && <Gap height={8} />}
      {data_management && (
        <Button link={!opt.tsum} large={opt.tsum} action={onData}>
          {i18n('UserDataManagement')}
        </Button>
      )}
    </Vertical>
  )
})
